module.exports = __webpack_public_path__ + "static/media/img_growth.725cf79f.png";